import { render, staticRenderFns } from "./BodyTable.vue?vue&type=template&id=cb7d961e&scoped=true&"
import script from "./BodyTable.vue?vue&type=script&lang=ts&"
export * from "./BodyTable.vue?vue&type=script&lang=ts&"
import style0 from "./BodyTable.vue?vue&type=style&index=0&id=cb7d961e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7d961e",
  null
  
)

export default component.exports